import React from 'react';

import { translate } from 'sharedreact/utils/LanguageSupport';

type Props = {
  id: string,
  language: string,
  kbUrl?: string,
  draftKBURL?: boolean
};

class HttpWarning extends React.Component<Props> {
  override render (): React.ReactNode {
    const {
      id,
      language, // eslint-disable-line no-unused-vars
      kbUrl,
      draftKBURL
    } = this.props;

    const goToKnowledgeBaseString: string = (draftKBURL
      ? translate('shared.httpwarning.gotoknowledgebase') + ' (draft)'
      : translate('shared.httpwarning.gotoknowledgebase'));

    return (
      <div className='esko_httpwarning esko_logintextsmall'>
        <div className='esko_httpwarningmessage'>
          <div className='esko_icon esko_icon-warning esko_httpwarning_icon' /> {translate('shared.httpwarning.message')}
        </div>
        <div className='esko_httpwarningdescription'>
          {translate('shared.httpwarning.description')}
        </div>
        <div>
          {kbUrl != null
            ? <a id={id} href={kbUrl} target='_blank'>{goToKnowledgeBaseString}</a>
            : <a id={id} role='button' target='_blank' className='disabled'>{goToKnowledgeBaseString}</a>
          }
        </div>
      </div>
    );
  }
}

export default HttpWarning;
